import React from "react";
import PropTypes from "prop-types";
import styles from "./index.css";
import withTranslation from "../../../translation";

const DeleteItem = ({ deleteBagItem, id, formatTranslation }) => (
  <button
    aria-label={formatTranslation(`MiniBag.DeleteBagItemText`)}
    className={styles.deleteItem}
    onClick={e => {
      e.stopPropagation();
      deleteBagItem(id);
    }}
  />
);

DeleteItem.propTypes = {
  deleteBagItem: PropTypes.func.isRequired,
  formatTranslation: PropTypes.func,
  id: PropTypes.string.isRequired
};

export default withTranslation(DeleteItem);



// WEBPACK FOOTER //
// ./template/components/MiniBag/LineItem/DeleteItem/DeleteItem.js